import React, { useState } from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import { translations } from '../../../translations';
import { describeApiError, fillTemplate, formatDateTime } from '../../../utils/format';
import { requestJson } from '../../../utils/lifecycle';

export default function PublicationTab({ app, canEdit, onChanged }) {
  const { language } = useLanguage();
  const t = translations[language];
  const saved = app.publicationSummary || {};
  const [url, setUrl] = useState(saved.playStoreUrl || '');
  const [notes, setNotes] = useState(saved.releaseNotes || '');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState({ kind: '', text: '' });
  const readyToPublish = app.status === 'google_play_review';

  const run = async (path, method, body, done) => {
    setBusy(true);
    setMessage({ kind: '', text: '' });
    try {
      await requestJson(path, { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      setMessage({ kind: 'ok', text: done });
      await onChanged();
    } catch (error) {
      if (error.status !== 401) setMessage({ kind: 'error', text: describeApiError(error, t, error.message) });
    } finally {
      setBusy(false);
    }
  };

  const save = (event) => {
    event.preventDefault();
    run(`/custom-apps/${app.id}`, 'PATCH', { publicationSummary: { playStoreUrl: url.trim(), releaseNotes: notes } }, t.publicationSaved);
  };
  const publish = () => run(`/custom-apps/${app.id}/publish`, 'POST', { playStoreUrl: url.trim(), releaseNotes: notes }, t.statusUpdated);

  if (!canEdit) {
    return <section className="card stack">
      {saved.playStoreUrl
        ? <p><a href={saved.playStoreUrl} target="_blank" rel="noopener noreferrer">{t.openPlayStore}</a>{saved.publishedAt && ` · ${fillTemplate(t.publishedOn, { date: formatDateTime(saved.publishedAt, language) })}`}</p>
        : <p className="hint">{t.notPublishedYet}</p>}
      {saved.releaseNotes && <div><h3>{t.releaseNotes}</h3><p>{saved.releaseNotes}</p></div>}
      <p className="hint">{t.publicationReadOnly}</p>
    </section>;
  }

  return <section className="card stack">
    {saved.publishedAt && <p>{fillTemplate(t.publishedOn, { date: formatDateTime(saved.publishedAt, language) })}{' '}
      {saved.playStoreUrl && <a href={saved.playStoreUrl} target="_blank" rel="noopener noreferrer">{t.openPlayStore}</a>}</p>}
    <form className="stack" onSubmit={save}>
      <div className="field">
        <label className="label" htmlFor="play-store-url">{t.playStoreUrl}</label>
        <input id="play-store-url" className="input" type="url" value={url} onChange={(event) => setUrl(event.target.value)} placeholder="https://play.google.com/store/apps/details?id=" />
      </div>
      <div className="field">
        <label className="label" htmlFor="release-notes">{t.releaseNotes}</label>
        <textarea id="release-notes" className="textarea" rows="3" value={notes} onChange={(event) => setNotes(event.target.value)} maxLength={4000} />
      </div>
      <div className="btn-row">
        <button className="btn" type="submit" disabled={busy}>{t.saveLink}</button>
        {readyToPublish && <button className="btn btn--primary" type="button" disabled={busy || !url.trim()} onClick={publish}>{t.publishApp}</button>}
      </div>
      {readyToPublish && <p className="hint">{t.publishHelp}</p>}
    </form>
    {message.text && <p className={message.kind === 'error' ? 'notice notice--error' : 'hint'} role={message.kind === 'error' ? 'alert' : 'status'}>{message.text}</p>}
  </section>;
}
